import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import * as React from "react";
import {useContext, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import dayjs from "dayjs";
import {useLookupActions} from "../../../service/useLookupActions";
import {useStatusValuesCouponCampaign} from "../../../component/useStatusValuesCouponCampaign";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {intToFloatCurrency} from "../../../component/Utils";

const CouponCampaignDetailModal = (props: any) => {
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'coupon'});
    const {t : t2}= useTranslation(['salesmarketing']);

    const {getStatusLabel} = useStatusValuesCouponCampaign();
    const {getRatePlanInfoByProductCode} = useLookupActions();
    const [lmsList, setLmsList] = useState<any[]>([]);
    const [dropDmsList, setDropDmsList] = useState<any[]>([]);
    const [ancillaryNameList, setAncillaryNameList] = useState<any[]>([]);
    const theme = useTheme();
    const {couponCampaign} = props;
    const {globalData} = useContext(GlobalContext);

    useEffect(() => {
        if (couponCampaign) {
            getRatePlanInfoByProductCode(couponCampaign.productCode).then(res => {
                if(res && res.locations && res.ancillaries) {
                    setLmsList(res.locations);
                    setDropDmsList(res.locations);
                    setAncillaryNameList(res.ancillaries);
                }
            })
        }
    }, [couponCampaign])

    return (
        couponCampaign && <Dialog scroll={"paper"} maxWidth={"lg"} disableEscapeKeyDown fullWidth={true} open={props.open}
                         onClose={() => {
                             return;
                         }}>
            <DialogTitle>
                <Typography fontWeight={"bold"} color={"primary"}>
                    {t('details')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        props.handleClose();
                    }}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                    }}
                >
                    <CloseRoundedIcon/>
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    {(globalData?.user?.legalEntities?.length > 1 || globalData?.user?.dealers?.length > 1) &&
                        < Grid container item xs={12} spacing={1}>
                            {globalData?.user?.legalEntities?.length > 1 &&
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        label={t('legalEntityField')}
                                        value={couponCampaign.tenantId}
                                        margin="dense"
                                        variant="standard"
                                        inputProps={
                                            {readOnly: true}
                                        }
                                    >
                                    </TextField>
                                </Grid>
                            }
                            {globalData?.user?.dealers?.length > 1 &&
                                <Grid item xs={3}>
                                    <TextField
                                        fullWidth
                                        label={t('dealerField')}
                                        value={couponCampaign.dealerId}
                                        margin="dense"
                                        variant="standard"
                                        inputProps={
                                            {readOnly: true}
                                        }
                                    >
                                    </TextField>
                                </Grid>
                            }
                        </Grid>
                    }
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('status')}
                            fullWidth
                            variant="standard"
                            value={getStatusLabel(couponCampaign.status)}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('productCode')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.productCode}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={6}/>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('bookingStartDate')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.bookingStartDate ? dayjs(couponCampaign.bookingStartDate).format("L") : null}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('bookingEndDate')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.bookingEndDate ? dayjs(couponCampaign.bookingEndDate).format("L") : null}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('pickupStartDate')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.pickupStartDate ? dayjs(couponCampaign.pickupStartDate).format("L") : null}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('pickupEndDate')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.pickupEndDate ? dayjs(couponCampaign.pickupEndDate).format("L") : null}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('acrissCode')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.acrissCodeList.join(", ")}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('lms')}
                            fullWidth
                            variant="standard"
                            value={lmsList.length > 0 ? couponCampaign.lmsList.map((l: any) => lmsList.find((ll:any) => ll.id === l)?.name).join(', ') : ""}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            id="dropDmsList"
                            label={t('dropDms')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.dropDmsList && dropDmsList.length > 0 ? couponCampaign.dropDmsList.map((l: any) => dropDmsList.find((ll:any) => ll.id === l)?.name).join(', ') : ""}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={9}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('description')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.description}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('availableCodes')}
                            fullWidth
                            variant="standard"
                            value={((couponCampaign.couponTotal != null ? couponCampaign.couponTotal : 0) - (couponCampaign.couponTotal != null ? couponCampaign.couponUsed : 0)) + "/" + (couponCampaign.couponTotal != null ? couponCampaign.couponTotal : 0)}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="discountPercentage"
                            label={t('discountPercentage')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.discountPercentage? couponCampaign.discountPercentage : '--'}
                            inputProps={
                                { readOnly: true }
                            }
                            InputProps={{
                                startAdornment: <InputAdornment position="start">%</InputAdornment>,
                            }}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="discountAmount"
                            label={t('discountAmount')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.discountAmount? intToFloatCurrency(couponCampaign.discountAmount): '--'}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('freeDays')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.freeDays}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('minDuration')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.minimumDuration}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            margin="dense"
                            id="status"
                            label={t('minDurationForFreeDays')}
                            fullWidth
                            variant="standard"
                            value={couponCampaign.minimumDurationForFreeDays}
                            inputProps={
                                { readOnly: true }
                            }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={5} sx={{padding: "15px"}} justifyContent={"space-between"}>
                    {couponCampaign.exclusionSubperiods && couponCampaign.exclusionSubperiods.length > 0 && <Grid container item xs={12}>
                        <Typography>
                            {t('subPeriods.title')}
                        </Typography>
                        <TableContainer sx={{paddingTop: "10px"}}>
                            <Table aria-label="subPeriods-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t2('subPeriods.startDate')}</TableCell>
                                        <TableCell>{t2('subPeriods.endDate')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {couponCampaign.exclusionSubperiods.map((row: any, index: number) => (
                                        <TableRow
                                            key={"sub" + index}
                                        >
                                            <TableCell>{dayjs(row.startDate).format("L")}</TableCell>
                                            <TableCell>{dayjs(row.endDate).format("L")}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>}
                    {ancillaryNameList.length > 0 && couponCampaign.ancillaryList && couponCampaign.ancillaryList.length > 0 && <Grid item xs={6}>
                        <Typography>
                            {t('ancillaryDiscount.title')}
                        </Typography>
                        <TableContainer sx={{paddingTop: "10px"}}>
                            <Table aria-label="ancillaryDiscount-table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('ancillaryDiscount.name')}</TableCell>
                                        <TableCell>{t('ancillaryDiscount.discount')}</TableCell>
                                        <TableCell>{t('ancillaryDiscount.amount')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {couponCampaign.ancillaryList.map((row: any, index: number) => (
                                        <TableRow
                                            key={"anc" + index}
                                        >
                                            <TableCell>{ancillaryNameList.find((aa:any) =>  aa.id === parseInt(row.ida))?.name}</TableCell>
                                            <TableCell>{row.discount ? ("%" + row.discount) : "--"}</TableCell>
                                            <TableCell>{row.amount ? intToFloatCurrency(row.amount): '--'}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>}
                </Grid>
            </DialogContent>
            <DialogActions style={{backgroundColor: theme.palette.neutral.main}}>
                <Button color={"accent"}
                        onClick={() => props.handleClose()}>{t('buttons.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default CouponCampaignDetailModal;